import { render, staticRenderFns } from "./SecurityPanel.vue?vue&type=template&id=525fd291&"
import script from "./SecurityPanel.vue?vue&type=script&lang=ts&"
export * from "./SecurityPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SecurityPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports